import { useState, useEffect } from 'react';

const MQ = window.matchMedia('(min-width: 2555px)');

export function useIs2K() {
  const [is2K, setIs2K] = useState(MQ.matches);
  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => setIs2K(e.matches);
    MQ.addEventListener('change', handler);
    return () => MQ.removeEventListener('change', handler);
  }, []);
  return is2K;
}
